export default [
  {
    name: 'CART',
    slug: 'cart',
    text: ''
  },
  {
    name: 'CAPTURE',
    slug: 'capture',
    text: ''
  },
  {
    name: 'CONVERT',
    slug: 'convert',
    text: ''
  },
  {
    name: 'GALLERY',
    slug: 'gallery',
    text: ''
  },
  {
    name: 'RATE',
    slug: 'rate',
    text: ''
  },
  {
    name: 'MultiCart',
    slug: 'multicart',
    text: ''
  }
]



// WEBPACK FOOTER //
// ./client/store/imports/AttachFamilyList.js